import { PushedBar } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
export function WorkflowWrapper({ onBack, backLabel, barEnd, children }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PushedBar, {
        onBack: onBack,
        backLabel: backLabel ?? t("workflows.multiple"),
        end: barEnd
    }), children);
}
